export default "__VITE_ASSET__71937348__"